import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Button, Icon } from "abs-ui-components";
import EuVoyagesDerogationCCSandCCU from "./DerogationCCSandCCU";
import EuVoyagesDerogationGeographicScope from "./DerogationGeographicScope";
import EuVoyagesDerogationIceClass from "./DerogationIceClass";
import EuVoyagesDerogationOMR from "./DerogationOMR";
import EuVoyagesDerogationPhaseIn from "./DerogationPhaseIn";
import EuVoyagesEmissionAfterDerogation from "./EmissionsAfterDerogations";
import EmissionsReported from "./EmissionsReported";
import axiosHttp from "../../../../../../services/interceptor";
import EUMRVVoyagesOld from "./EmissionReportedOld";
import Loader from "../../../../../../common/Loader/Loader";
import { roundNumericValues } from "../../../../../../common/utils/RoundNumericValues";

const EUMRVVoyages = () => {
	const [isExpanded, setIsExpanded] = useState(false);
	const [loading, setLoading] = useState(true);
	const [data, setEUMRVData] = useState([]);

	const toggleExpandCollapse = () => {
		setIsExpanded((prev) => !prev);
	};

	const reportDetails = useSelector(
		(state) => state.reports.selectedReportDetails
	);

	const fetchEUMRVVoyagesData = async () => {
		setLoading(true);
		try {
			const EUMRVVoyagesData = await axiosHttp({
				url: `api/Report/GetFuelEuMrvVoyages?childReportId=${reportDetails?.ReportMstId}`,
				method: "GET",
			});
			setLoading(false);
			if (EUMRVVoyagesData?.data?.data) {
				setLoading(false);
				setEUMRVData(
					roundNumericValues(EUMRVVoyagesData?.data?.data, 3)
				);
			} else if (EUMRVVoyagesData?.data) {
				setLoading(false);
				setEUMRVData(roundNumericValues(EUMRVVoyagesData?.data, 3));
			} else {
				setLoading(false);
				setEUMRVData([]);
			}
		} catch (error) {
			setLoading(false);
			console.error(error);
		}
	};

	useEffect(() => {
		fetchEUMRVVoyagesData();
	}, []);

	return (
		<>
			{loading ? (
				<div className="loader">
					<Loader />
				</div>
			) : (
				<>
					{data && data?.reportView === "2.0" ? (
						<>
							<EmissionsReported
								data={data?.voyageList || []}
								loading={loading}
							/>

							<div className="mt-4">
								<Button
									startIcon={
										<Icon
											icon={
												isExpanded
													? "keyboard_arrow_up"
													: "keyboard_arrow_down"
											}
										/>
									}
									className="icon-gap"
									onClick={toggleExpandCollapse}
								>
									{!isExpanded
										? "Show Details"
										: "Hide Details"}
								</Button>
							</div>

							{isExpanded && (
								<>
									<EuVoyagesDerogationGeographicScope
										data={
											data?.derogationGeographicScopes ||
											[]
										}
										loading={loading}
									/>
									<EuVoyagesDerogationCCSandCCU
										data={data?.derogationCcs || []}
										loading={loading}
									/>
									<EuVoyagesDerogationOMR
										data={data?.derogationPorts || []}
										loading={loading}
									/>
									<EuVoyagesDerogationIceClass
										data={data?.derogationIceClasses || []}
										loading={loading}
									/>
									<EuVoyagesDerogationPhaseIn
										data={
											data?.derogationReportingYears || []
										}
										loading={loading}
									/>
								</>
							)}

							<EuVoyagesEmissionAfterDerogation
								data={data?.emissionsAfterDerogations || []}
								loading={loading}
							/>
						</>
					) : (
						data &&
						data?.length > 0 &&
						data[0]?.reportView === "1.0" && (
							<EUMRVVoyagesOld
								data={data || []}
								loading={loading}
							/>
						)
					)}
				</>
			)}
		</>
	);
};

export default EUMRVVoyages;
